import script from "./TabList.vue?vue&type=script&setup=true&lang=js"
export * from "./TabList.vue?vue&type=script&setup=true&lang=js"

import "./TabList.vue?vue&type=style&index=0&id=bde13496&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bde13496"]])

export default __exports__